<template>
  <div class="app-container cheliang-page">
    <div class="search-div common-section-bg">
      <div class="shaixuan-item">
        <el-input
          v-model="listQuery.account"
          clearable
          placeholder="账号名称"
          size="mini"
          style="width: 160px"
          @keyup.enter.native="handleSearch"
        />
      </div>
      <div class="shaixuan-item">
        <el-button type="primary" size="mini" class="btn-primary-blue" icon="el-icon-search" @click="handleSearch">查询</el-button>
        <el-button size="mini" @click="resetSearch">重置</el-button>
      </div>
      <div class="shaixuan-item">
        <el-button type="primary" size="mini" class="btn-primary-blue" icon="el-icon-plus" @click="openForm()">分配权限</el-button>
      </div>
    </div>
    <div v-loading="listLoading" class="common-section-bg common-section-body table-wrap">
      <el-table :data="permissionList" size="mini" style="width: 100%; min-height: 300px">
        <el-table-column prop="account" label="账号" width="120" show-overflow-tooltip />
        <el-table-column prop="name" label="姓名" width="100" show-overflow-tooltip />
        <el-table-column prop="role" label="角色" width="140" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-tag size="mini" :type="roleTagType(scope.row.role)">{{ scope.row.role || '-' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="projects" label="可管理项目" min-width="220" show-overflow-tooltip />
        <el-table-column prop="update_time" label="更新时间" width="160" show-overflow-tooltip />
        <el-table-column label="操作" width="140" fixed="right" align="center">
          <template slot-scope="scope">
            <div class="table-action-btns">
              <el-button type="primary" size="mini" class="btn-edit-green" @click="openForm(scope.row)">编辑</el-button>
              <el-button type="danger" size="mini" @click="handleRemove(scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.size"
        @pagination="getList"
      />
    </div>

    <el-dialog
      custom-class="chechang-form-dialog"
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="560px"
      append-to-body
      @close="resetForm"
    >
      <div class="chechang-dialog-body vd-panel">
        <div class="vd-section vd-section-last vd-form-panel">
          <div class="vd-section-head">
            <span class="vd-section-bar" />
            <span>权限配置</span>
          </div>
          <el-form ref="formRef" :model="form" :rules="rules" label-width="100px">
            <el-form-item label="账号" prop="admin_id">
              <el-select
                v-model="form.admin_id"
                filterable
                clearable
                placeholder="请选择后台账号（可搜索）"
                style="width: 100%"
                :disabled="isEdit"
                @change="handleAdminChange"
              >
                <el-option
                  v-for="item in adminOptions"
                  :key="item.id"
                  :label="item.account"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="姓名">
              <el-input v-model="form.name" disabled placeholder="选择账号后自动带出" />
            </el-form-item>
            <el-form-item label="角色">
              <el-input v-model="form.role" disabled placeholder="选择账号后自动带出" />
            </el-form-item>
            <el-form-item label="管理项目" prop="community_ids">
              <el-select
                v-model="form.community_ids"
                multiple
                filterable
                reserve-keyword
                collapse-tags
                clearable
                placeholder="请选择可管理的小区（可搜索）"
                style="width: 100%"
              >
                <el-option
                  v-for="item in communityOptions"
                  :key="item.id"
                  :label="item.commName"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" class="btn-primary-blue" :loading="submitLoading" @click="handleSave">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import chechangPermission from '@/api/tianzheng/chechangPermission'
import communityApi from '@/api/tianzheng/Qu'

export default {
  name: 'ChechangPermission',
  components: { Pagination },
  data() {
    return {
      listLoading: false,
      submitLoading: false,
      permissionList: [],
      total: 0,
      listQuery: {
        page: 1,
        size: 10,
        account: ''
      },
      adminOptions: [],
      communityOptions: [],
      dialogVisible: false,
      isEdit: false,
      form: {
        admin_id: '',
        name: '',
        role: '',
        community_ids: []
      },
      rules: {
        admin_id: [{ required: true, message: '请选择账号', trigger: 'change' }],
        community_ids: [{ type: 'array', required: true, message: '请至少选择一个管理项目', trigger: 'change' }]
      }
    }
  },
  computed: {
    dialogTitle() {
      return this.isEdit ? '编辑车场权限' : '分配车场权限'
    }
  },
  created() {
    this.getList()
    this.loadSelectOptions()
  },
  methods: {
    normalizeIds(ids) {
      return (ids || []).map(id => Number(id)).filter(id => !Number.isNaN(id))
    },
    mergeCommunityOptions(row) {
      const ids = this.normalizeIds(row.community_ids)
      const names = String(row.projects || '').split('、').filter(Boolean)
      ids.forEach((id, index) => {
        if (!this.communityOptions.some(item => item.id === id)) {
          this.communityOptions.push({
            id,
            commName: names[index] || `小区${id}`
          })
        }
      })
    },
    roleTagType(role) {
      if (!role) return 'info'
      if (role.indexOf('财务') !== -1) return 'warning'
      if (role.indexOf('管理员') !== -1) return 'danger'
      return 'success'
    },
    loadSelectOptions() {
      chechangPermission.adminSelect().then(res => {
        if (res.code === 200) {
          this.adminOptions = (res.result || []).map(item => ({
            ...item,
            id: Number(item.id)
          }))
        }
      })
      communityApi.select().then(res => {
        if (res.code === 200) {
          this.communityOptions = (res.result || []).map(item => ({
            ...item,
            id: Number(item.id)
          }))
        }
      })
    },
    getList() {
      this.listLoading = true
      chechangPermission.list(this.listQuery).then(res => {
        this.listLoading = false
        if (res.code === 200) {
          this.permissionList = res.result.list || []
          this.total = res.result.total || 0
        }
      }).catch(() => {
        this.listLoading = false
      })
    },
    handleSearch() {
      this.listQuery.page = 1
      this.getList()
    },
    resetSearch() {
      this.listQuery.account = ''
      this.listQuery.page = 1
      this.getList()
    },
    openForm(row) {
      this.isEdit = !!row
      if (row) {
        this.mergeCommunityOptions(row)
        this.form = {
          admin_id: Number(row.admin_id),
          name: row.name,
          role: row.role,
          community_ids: this.normalizeIds(row.community_ids)
        }
        this.dialogVisible = true
        return
      }
      this.resetForm()
      this.dialogVisible = true
    },
    handleAdminChange(adminId) {
      const admin = this.adminOptions.find(item => item.id === adminId)
      if (!admin) {
        this.form.name = ''
        this.form.role = ''
        return
      }
      this.form.name = admin.name
      this.form.role = admin.role
    },
    handleSave() {
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        this.submitLoading = true
        chechangPermission.save({
          admin_id: this.form.admin_id,
          community_ids: this.form.community_ids
        }).then(res => {
          this.submitLoading = false
          if (res.code === 200) {
            this.$message.success('保存成功')
            this.dialogVisible = false
            this.getList()
          }
        }).catch(() => {
          this.submitLoading = false
        })
      })
    },
    handleRemove(row) {
      this.$confirm(`确定删除账号「${row.account}」的车场权限配置吗？`, '提示', {
        type: 'warning'
      }).then(() => {
        chechangPermission.remove({ admin_id: row.admin_id }).then(res => {
          if (res.code === 200) {
            this.$message.success('删除成功')
            this.getList()
          }
        })
      }).catch(() => {})
    },
    resetForm() {
      this.form = {
        admin_id: '',
        name: '',
        role: '',
        community_ids: []
      }
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import './styles/page.scss';
</style>

<style lang="scss">
@import './styles/panel.scss';
</style>
